import React, { Component } from 'react';
import { partnerApi, getAllverticalData, getAllcategoryData } from  './../../../API/FetchCall';
import SimpleReactValidator from 'simple-react-validator';
 
import {
  Collapse,
  CardBody,
  Card,
  CardHeader
} from 'reactstrap';
class JobPosting extends Component {
  constructor(props) {
    super(props);
 
  }
 
  render() {
 
    return (
      <React.Fragment>
        <div className="">
          <h3 className="page-header">Job Posting</h3>
           
        </div>
      </React.Fragment>
    );
  }
  
}

export default JobPosting;



// WEBPACK FOOTER //
// ./src/components/bewise/partners/tabbedjobposting.jsx